import { AlertCircle } from "lucide-react";

export default function DisclosureBanner({ compact = false }) {
  return (
    <div data-testid="fedex-disclosure-banner" className={`bg-slate-900 border-y border-amber-500/30 ${compact ? "py-2" : "py-3"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center gap-3">
        <AlertCircle className="w-4 h-4 text-amber-400 flex-shrink-0" />
        <p className="text-xs sm:text-sm text-slate-300 leading-snug">
          <span className="font-semibold text-amber-400">Independent Service Provider Disclosure:</span>{" "}
          Integrity Delivered, Inc. is an independently owned and operated business under contract with FedEx Ground.
          We are <span className="font-semibold">not</span> FedEx Corporation.
        </p>
      </div>
    </div>
  );
}
